const question1 = {
    'question': 'Czym jest psychoterapia dzieci i młodzieży?',
    'answer': '<p>Psychoterapia dzieci i młodzieży to forma psychoterapii, która koncentruje się na problemach dzieci i młodzieży. Celem terapii jest poprawa funkcjonowania dziecka lub nastolatka w różnych obszarach jego życia, takich jak relacje z innymi, nauka, rozwój emocjonalny, czy samoocena.</p>' +
        '<p>Terapia dzieci i młodzieży może być stosowana w przypadku różnych problemów, takich jak: depresja, lęk, problemy behawioralne, emocjonalne czy szkolne.</p>',
}

export default question1;